import { render, staticRenderFns } from "./EditPavementCaseModal.vue?vue&type=template&id=624b87ff"
import script from "./EditPavementCaseModal.vue?vue&type=script&lang=js"
export * from "./EditPavementCaseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports